/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DafUploadPagedList } from '../../models/daf-upload-paged-list';
import { DafUploadSortFieldName } from '../../models/daf-upload-sort-field-name';
import { SortDirection } from '../../models/sort-direction';

export interface SearchDafUploadList$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The search text to filter API
 */
  search?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the name
 */
  sortFieldName?: DafUploadSortFieldName;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
}

export function searchDafUploadList(http: HttpClient, rootUrl: string, params?: SearchDafUploadList$Params, context?: HttpContext): Observable<StrictHttpResponse<DafUploadPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchDafUploadList.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DafUploadPagedList>;
    })
  );
}

searchDafUploadList.PATH = '/custom/daf/uploads/search';
